module.exports = "<div class=\"page\">\n  <h1 class=\"main-title\">Datamart Management Site</h1>\n  <a routerLink=\"/transactions\">Campaign Transactions</a><br>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard.component.html
// module id = ./src/app/modules/dashboard/dashboard.component.html
// module chunks = main